import { z } from 'zod';
import { zfd } from 'zod-form-data';
import {
  makeDraftClaimLineItemAction,
  makeDraftClaimLineItemLoader,
  redirect,
} from '~/utils/routing';

export const { loader, useLoaderData } = makeDraftClaimLineItemLoader(
  ({ context }) => {
    const {
      draftClaimLineItem: {
        quantity,
        lineItem: { remainingReturnableQuantity },
      },
      crewClaim: { claimType },
    } = context;

    return remainingReturnableQuantity === 1 ?
        redirect('reason')
      : {
          remainingReturnableQuantity,
          quantity,
          claimType,
        };
  },
);

export const INPUT_KEY = 'quantity';

const makeFormSchema = (remainingReturnableQuantity: number) =>
  zfd.formData({
    [INPUT_KEY]: zfd.numeric(
      z.number().min(1).max(remainingReturnableQuantity),
    ),
  });

export const { action, useActionResult } = makeDraftClaimLineItemAction(
  ({ formData, context: { draftClaimLineItem } }, appStore) => {
    const result = makeFormSchema(
      draftClaimLineItem.lineItem.remainingReturnableQuantity,
    ).safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Invalid data submitted. Please try again.',
      };
    }

    appStore.dispatch(
      appStore.actions.draftClaimLineItem.setQuantity(result.data.quantity),
    );

    return redirect('reason');
  },
);
